import React, { useState } from 'react';
import {
  FiChevronUp,
  FiChevronDown,
  FiChevronLeft,
  FiChevronRight,
  FiCircle,
  FiHome,
  FiArrowLeft,
  FiMenu,
} from 'react-icons/fi';
import { LUNA_COMMANDS } from '../../../../../types/flow';
import { cn } from '../lib/utils';

interface TVRemoteProps {
  onCommandPress: (command: string, label: string) => void;
}

interface RemoteButtonProps {
  label: string;
  onClick: () => void;
  children?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
}

const RemoteButton: React.FC<RemoteButtonProps> = ({
  label,
  onClick,
  children,
  size = 'md',
}) => {
  const [pressed, setPressed] = useState(false);

  return (
    <button
      type="button"
      onClick={() => {
        setPressed(true);
        onClick();
        setTimeout(() => setPressed(false), 120);
      }}
      className={cn(
        'adslot-remote-button',
        `adslot-remote-btn-${size}`,
        pressed && 'adslot-remote-button-pressed',
      )}
      title={label}
    >
      {children || label}
    </button>
  );
};

export const TVRemote: React.FC<TVRemoteProps> = ({ onCommandPress }) => {
  const press = (key: keyof typeof LUNA_COMMANDS) => {
    const cmd = LUNA_COMMANDS[key];
    onCommandPress(cmd.command, cmd.label);
  };

  return (
    <div className="adslot-remote">
      <div className="adslot-remote-header">Remote</div>

      <div className="adslot-remote-row">
        <RemoteButton size="sm" label="BACK" onClick={() => press('BACK')}>
          <FiArrowLeft />
        </RemoteButton>
        <RemoteButton size="sm" label="HOME" onClick={() => press('HOME')}>
          <FiHome />
        </RemoteButton>
        <RemoteButton size="sm" label="MENU" onClick={() => press('MENU')}>
          <FiMenu />
        </RemoteButton>
      </div>

      <div className="adslot-remote-dpad">
        <RemoteButton label="UP" onClick={() => press('UP')}>
          <FiChevronUp />
        </RemoteButton>

        <div className="adslot-remote-dpad-middle">
          <RemoteButton label="LEFT" onClick={() => press('LEFT')}>
            <FiChevronLeft />
          </RemoteButton>

          <RemoteButton size="lg" label="OK" onClick={() => press('OK')}>
            <FiCircle />
          </RemoteButton>

          <RemoteButton label="RIGHT" onClick={() => press('RIGHT')}>
            <FiChevronRight />
          </RemoteButton>
        </div>

        <RemoteButton label="DOWN" onClick={() => press('DOWN')}>
          <FiChevronDown />
        </RemoteButton>
      </div>

      <div className="adslot-remote-footer">Click buttons to add commands</div>
    </div>
  );
};
